import { memo, useEffect } from 'react';
import { IBaseProps } from 'src/types/common.type';
import { onMessageListener, requestPermissionNotification } from 'src/utils/firebase';
import MESSAGE from 'src/utils/message';

function NotificationProvider({ children }: IBaseProps) {
  useEffect(() => {
    requestPermissionNotification();

    onMessageListener().then((payload) => {
      if (!payload?.notification) return;
      MESSAGE.warning(`${payload.notification.title}: ${payload.notification.body}`);
    });
  }, []);

  return children;
}

export default memo(NotificationProvider);
